import { render, staticRenderFns } from "./purchasesDetail.vue?vue&type=template&id=e53379a4&scoped=true&"
import script from "./purchasesDetail.vue?vue&type=script&lang=js&"
export * from "./purchasesDetail.vue?vue&type=script&lang=js&"
import style0 from "./purchasesDetail.vue?vue&type=style&index=0&id=e53379a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53379a4",
  null
  
)

export default component.exports